import { useEffect, useState } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import style from './GeneralLayout.module.css';
import { NavPanel } from './components/NavPanel';
import { NotificationOnMeeting } from './components/NotificationOnMeeting';
import { TopPanel } from './components/TopPanel';
import { pathWithoutNavBarAndTopPanel } from './constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useUsersStore } from '@/stores/users';
import { EUserRoles } from '@/types';

const customBgColors: Record<string, Partial<Record<EUserRoles, string>>> = {
  // '/dashboard': {
  //   [UserRoles.PROVIDER]: 'var(--colors-white)',
  //   [UserRoles.PATIENT]: 'var(--colors-primary)',
  // },
};

/**
 * General layout component that includes navigation panel, top panel and an outlet for nested routes.
 * Note: NavPanel is positioned at the bottom for small screens to prevent layout overlap issues.
 * @returns The GeneralLayout component.
 */
export const GeneralLayout = () => {
  const isSmallScreen = useMediaQuery('(max-width: 1280px)');
  const [bgColor, setBgColor] = useState('#FFF');
  const location = useLocation();
  const { role } = useUsersStore((state) => ({
    role: state.role,
  }));

  useEffect(() => {
    const check = Object.keys(customBgColors).find((key) =>
      location.pathname.includes(key),
    );

    if (check && role) {
      const roleBasedColor = customBgColors[check]?.[role] || '#FFF';
      setBgColor(roleBasedColor);
      return;
    }
    setBgColor('#FFF');
  }, [location.pathname, role]);

  if (
    pathWithoutNavBarAndTopPanel.some((path) =>
      matchPath(path, location.pathname),
    )
  ) {
    return (
      <div className={style.wrapper}>
        <NotificationOnMeeting />
        <main className={style.main}>
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className={style.wrapper}>
      {!isSmallScreen && <NavPanel />}
      <div className={style.contentWrapper}>
        <TopPanel />
        <NotificationOnMeeting />
        <main
          className={style.innerWrapper}
          style={{ backgroundColor: bgColor }}
        >
          <Outlet />
        </main>
      </div>
      {isSmallScreen && <NavPanel />}
    </div>
  );
};
